"use strict";
import {registerPlugin} from "@wordpress/plugins"
import {PluginSidebar, PluginSidebarMoreMenuItem} from "@wordpress/edit-post";
import buildStore from './data/store';
import ProviderWrapper from "./context/ProviderWrapper";
import {usePostId} from "./hook/useEditPost"
import {EventsPanel, PageviewsPanel, RefererPanel} from "./components/GutenbergSidebar/GutenbergSidebar";

const store = buildStore();
registerPlugin( 'octavius-rocks', {
    render: ()=>{
        const postId = usePostId();
        return (
            <div>
                <PluginSidebarMoreMenuItem
                    target="octavius-rocks"
                    icon="chart-bar"
                >
                    Octavius Rocks
                </PluginSidebarMoreMenuItem>
                <PluginSidebar
                    name="octavius-rocks"
                    icon="chart-bar"
                    title="Octavius Rocks Analytics"
                >
                    <ProviderWrapper store={store}>
                        <PageviewsPanel postId={postId} />
                        <EventsPanel postId={postId} />
                        <RefererPanel postId={postId} />
                    </ProviderWrapper>

                </PluginSidebar>
            </div>
        )
    }
})


